import { FleetEntry } from "@shared/platform-api/generated"
import { createRequest, Data, platform } from "@shared/platform-api/requests"
import { EmbeddedMotorVehicle } from "@shared/types"
import { ModernFleetEntry } from "@shared/utils/compatibility"
import { localDateFromString } from "@shared/utils/formatters/dates"
import { createRequestHook } from "../../../../api/createRequestHook"

export type FetchFleetEntriesInput = Readonly<{
  policyId: string
  limit?: number
  next?: string
}>
type Output = Data<EmbeddedMotorVehicle>

export const fetchFleetEntries = createRequest<FetchFleetEntriesInput, Output>(
  async (input, getToken): Promise<Output> => {
    const { policyId, limit } = input

    const result: Data<FleetEntry> = await platform(getToken).fleets.fleetEntries({
      id: policyId,
      include: `make,model`,
      limit,
    })

    return { ...result, items: result.items.map(convertFleetEntryToEmbeddedMotorVehicle) }
  }
)

const convertFleetEntryToEmbeddedMotorVehicle = (fleetEntry: ModernFleetEntry): EmbeddedMotorVehicle => ({
  registrationNumber: fleetEntry.vrn,
  onCoverDate: localDateFromString(fleetEntry.onCoverDate),
  offCoverDate: fleetEntry.offCoverDate ? localDateFromString(fleetEntry.offCoverDate) : null,
  vehicle: {
    manufacturer: fleetEntry.vehicle.make ?? ``,
    model: fleetEntry.vehicle.model ?? ``,
    abiGroup: fleetEntry.vehicle.abiGroup ?? null,
  },
})

export const useFetchFleetEntries = createRequestHook(fetchFleetEntries)
